export function EikoLogo({ className }: { className?: string }) {
  return (
    <svg
      viewBox="0 0 6490 3510"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g transform="translate(0,3510) scale(1,-1)">
        <path d="M3555 3352 c-66 -15 -114 -105 -220 -412 -106 -308 -130 -383 -230
-720 -60 -204 -63 -215 -128 -425 -25 -79 -84 -247 -105 -295 -6 -14 -27 -65
-48 -115 -115 -280 -276 -529 -453 -698 -62 -60 -74 -68 -103 -65 -29 3 -35 8
-46 43 -30 89 2 258 89 470 4 11 33 85 64 164 31 79 60 151 65 160 15 29 71
183 107 291 21 64 37 135 40 182 l6 76 -44 28 c-63 40 -116 56 -182 55 -99 -1
-144 -37 -211 -171 -24 -47 -47 -96 -51 -110 -4 -14 -13 -38 -20 -55 -7 -16
-38 -105 -69 -196 -63 -186 -81 -225 -161 -339 -30 -43 -55 -83 -55 -88 0 -6
-7 -12 -15 -16 -8 -3 -15 -11 -15 -17 0 -18 -134 -172 -192 -221 -48 -40 -84
-65 -160 -111 -15 -9 -58 -29 -95 -43 -62 -24 -81 -27 -218 -28 -130 -1 -155
2 -190 19 -66 32 -127 103 -152 176 -28 80 -48 251 -33 279 6 11 12 20 13 20
1 0 27 -24 58 -53 30 -29 77 -63 104 -76 61 -29 172 -38 246 -21 259 60 469
415 470 793 1 229 -71 381 -203 427 -83 29 -277 28 -385 -1 -277 -75 -532
-302 -694 -617 -27 -52 -49 -103 -49 -113 0 -10 -3 -19 -8 -19 -7 0 -35 -81
-77 -218 -20 -68 -45 -266 -45 -362 1 -386 152 -628 455 -731 63 -21 87 -24
235 -23 147 1 174 4 250 26 98 30 233 91 321 146 65 40 205 148 228 175 20 25
41 21 41 -7 0 -13 9 -55 21 -92 47 -154 122 -238 237 -264 107 -25 251 25 376
130 54 46 157 155 171 181 18 34 44 44 52 21 20 -57 68 -183 84 -220 25 -54
51 -65 159 -65 108 0 155 18 176 68 15 36 65 236 97 385 9 41 28 129 42 195
14 66 35 155 47 198 l20 78 42 -3 41 -3 23 -100 c12 -55 27 -129 33 -165 12
-81 47 -238 59 -265 5 -11 14 -38 21 -60 17 -58 63 -136 101 -172 45 -42 101
-69 175 -84 53 -10 73 -9 130 5 98 25 154 60 260 164 18 18 33 37 33 42 0 6 3
10 8 10 4 0 45 47 92 105 50 62 92 105 103 105 10 0 30 -20 47 -47 17 -27 34
-55 40 -63 5 -8 26 -40 47 -71 58 -88 185 -166 318 -194 119 -25 247 -14 365
33 66 26 83 35 155 81 173 110 374 351 464 556 17 38 66 186 81 244 18 69 34
86 113 115 258 98 327 141 391 245 61 99 88 259 47 280 -29 16 -90 -21 -221
-135 -87 -76 -129 -98 -183 -99 l-52 0 -3 35 c-11 155 -64 347 -123 447 -46
78 -132 164 -198 196 -267 135 -687 -58 -968 -443 -115 -158 -173 -287 -277
-621 -67 -217 -161 -355 -301 -445 -51 -32 -70 -39 -125 -42 -63 -4 -66 -3
-102 32 -71 69 -98 155 -183 570 -7 34 106 134 395 351 223 166 252 190 350
282 49 46 55 56 54 91 -1 42 -16 64 -83 129 -56 53 -114 69 -194 54 -136 -25
-255 -117 -518 -397 -170 -181 -249 -240 -249 -186 0 29 47 201 76 277 14 39
34 93 44 121 10 28 23 60 29 70 5 10 24 53 41 94 44 107 80 190 96 227 8 17
14 34 14 38 0 4 6 21 14 38 102 224 165 507 142 631 -9 47 -54 98 -109 124
-42 19 -135 33 -172 24z m-2178 -1291 c129 -128 -25 -489 -267 -627 -90 -52
-212 -68 -290 -40 -32 12 -35 16 -34 52 0 22 13 73 29 114 30 77 111 241 124
250 4 3 18 23 31 45 76 126 230 233 337 234 33 1 47 -5 70 -28z m4145 -170 c4
-4 16 -59 25 -124 21 -142 19 -146 -63 -128 -79 18 -126 63 -148 140 -15 53
-14 96 1 124 5 9 174 -2 185 -12z m-496 -236 c31 -68 114 -159 191 -211 32
-22 60 -42 61 -46 2 -5 7 -8 12 -8 4 0 42 -21 84 -46 88 -53 89 -58 52 -158
-77 -203 -303 -411 -462 -424 -107 -9 -172 37 -224 158 -21 49 -24 69 -24 185
0 72 6 148 12 170 6 22 18 68 26 102 33 132 121 274 194 312 20 11 41 20 45
21 4 0 20 -25 33 -55z" />
        <path d="M2605 2918 c-43 -15 -73 -45 -100 -101 -42 -82 -103 -279 -110 -354
l-7 -72 32 -20 c34 -20 146 -44 210 -44 20 0 50 8 68 17 41 21 114 114 169
214 70 128 70 202 0 277 -24 25 -48 45 -54 45 -6 0 -16 6 -22 14 -11 13 -39
20 -126 31 -16 2 -43 -1 -60 -7z" />
      </g>
    </svg>
  );
}
